import { Container, Typography } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import { getClassColor } from '../utils/getClassColor';
import { AllocationSlice } from '../utils/walletSummary';

type WalletTotalProps = {
  total: number;
  change: number;
  allocation: AllocationSlice[];
  isMobile: boolean;
};

/** Valor total da carteira, variação em 24h e gráfico de pizza da alocação. */
export function WalletTotal({ total, change, allocation, isMobile }: WalletTotalProps) {
  return (
    <Container sx={{ display: 'flex', flexDirection: 'column', gap: '10px', padding: 0 }} maxWidth="md">
      <Typography variant='h4'>
        Total Carteira
      </Typography>
      {!!total && (
        <Container maxWidth="lg">
          <PieChart
            series={[{ data: allocation }]}
            height={isMobile ? undefined : 400}
            width={isMobile ? undefined : 400}
            margin={{ bottom: 0 }}
            hideLegend
          />
        </Container>
      )}
      <Container>
        <Typography variant='h5'>
          R${total.toFixed(2)}
        </Typography>
        <Typography variant='h6' className={getClassColor(change.toFixed(2))}>
          {change > 0 ? '+' : ''}R${change.toFixed(2)} {"(24h)"}
        </Typography>
      </Container>
    </Container>
  );
}
